import styled from "@emotion/styled";
import { Box } from "@mui/material";

export const LotInfoWrapper = styled(Box)(({ colors }) => ({
  background: colors.white,
  boxShadow: `0px 4px 32px 10px ${colors.lightIvory}`,
}));
